/**
 * Client-side timing for the AppSheet update callables that read the row before editing it
 * (updateSharedContact, updateRecurringSchedule, updateOnpointUser, updateGeneratorFile,
 * updateServiceFile, updatePartsCatalogEntry). #5111.
 *
 * MUST equal PRE_EDIT_WRITE_CALLABLE_TIMEOUT_SECONDS in
 * functions/src/dataHub/appsheet/preEditWriteBudget.ts. The codebases share no module, so a
 * server test reads this file and fails if the numbers diverge. The client must wait at least
 * that long or it reports "failed" for a save that is still running.
 */
export const PRE_EDIT_WRITE_SERVER_TIMEOUT_SECONDS = 300;

/**
 * The server's timeout plus 10s for the network round trip and cold start. The Firebase SDK
 * default (70s) is far shorter than the server's budget.
 */
export const PRE_EDIT_WRITE_CALLABLE_TIMEOUT_MS = PRE_EDIT_WRITE_SERVER_TIMEOUT_SECONDS * 1000 + 10_000;

/**
 * createPartsCatalogEntry (AppSheet wind-down, step A2) holds one AppSheet Add plus the lock and mirror writes under a 120s server
 * timeout (CREATE_PART_TIMEOUT_SECONDS in functions/src/fieldService/partsCatalogCreateApi.ts); the client waits 5s longer, so a create that is
 * still running is never reported as failed. A server test reads this file and fails if the two diverge.
 */
export const CREATE_PART_SERVER_TIMEOUT_SECONDS = 120;
export const CREATE_PART_CALLABLE_TIMEOUT_MS = CREATE_PART_SERVER_TIMEOUT_SECONDS * 1000 + 5_000;

